/**
 * RVO dierSoort — zelfde waarden als app/Enums/AnimalSpecies.php.
 */
export enum AnimalSpecies {
  Rund = '1',
  Varken = '2',
  Schaap = '3',
  Geit = '4',
  Paard = '7',
}

const ANIMAL_SPECIES_LABELS: Record<AnimalSpecies, string> = {
  [AnimalSpecies.Rund]: 'Rund',
  [AnimalSpecies.Varken]: 'Varken',
  [AnimalSpecies.Schaap]: 'Schaap',
  [AnimalSpecies.Geit]: 'Geit',
  [AnimalSpecies.Paard]: 'Paard',
};

const RVO_CODE_SET = new Set<string>(Object.values(AnimalSpecies));

export function animalSpeciesFromRvoCode(code: string): AnimalSpecies | null {
  const trimmed = code.trim();
  return RVO_CODE_SET.has(trimmed) ? (trimmed as AnimalSpecies) : null;
}

export function animalSpeciesLabel(code: string | null | undefined, fallback = '—'): string {
  if (!code?.trim()) {
    return fallback;
  }
  const species = animalSpeciesFromRvoCode(code);
  return species ? ANIMAL_SPECIES_LABELS[species] : `Soort ${code.trim()}`;
}

export function animalSpeciesSelectOptions(): Array<{ label: string; value: AnimalSpecies }> {
  return (Object.values(AnimalSpecies) as AnimalSpecies[]).map((value) => ({
    value,
    label: ANIMAL_SPECIES_LABELS[value],
  }));
}
